import React, { PropsWithChildren } from 'react';

interface State {
  error: any;
}

class ErrorBoundary extends React.Component<PropsWithChildren, State> {
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.error !== null) {
      return (
        <div style={{ textAlign: 'center', marginTop: '100px' }}>
          <h3>Ojdå, någonting gick fel. Var god försök igen</h3>
          {process.env.NODE_ENV === 'development' && <p>Message: {this.state.error.message}</p>}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
